/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import React, { Dispatch, SetStateAction, useContext } from "react";

import {
  FilterData,
  FilterFieldKey,
  FilterOptions,
  FilterOptionsCount,
  FilterProgramsCabins,
} from "./typing";

export const FilterContext = React.createContext<{
  filterOptions: FilterOptions;
  filterOptionsCount: FilterOptionsCount;

  filterProgramsCabins: FilterProgramsCabins;

  defaultFilterData: FilterData;
  filterData: FilterData;
  setFilterData: (value: Partial<FilterData>) => void;

  anchorEl: HTMLButtonElement | null;
  setAnchorEl: (e: HTMLButtonElement) => void;

  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;

  fieldId: FilterFieldKey;
  setFieldId: (id: FilterFieldKey) => void;

  resetFilterField: (key: keyof FilterData) => void;
  resetFilterData: () => void;
}>({});

export const FilterContextProvider = FilterContext.Provider;

export const useFilterContext = () => {
  return useContext(FilterContext);
};
